<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="800" height="600" :show-footer="false" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" title="平台登录" :loading="loading">
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="external‌loginList"></vxe-grid>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			action: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				currentrow: null,
				loading: false,
				model: true,
				tableList: [],
				orderinfo: [],
				gridOptions: null,
				tabledata: [],
				exportRef: 'export_' + Math.random(),
				primarykey: '业务订单号',
				buff: true,
				isfinish: true,
				totalNum: 0,
				progress: 0
			}
		},
		created() {

		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {

				gridOptions.height = 450
				gridOptions.columns = [{
						field: 'plant',
						title: '平台',
						width: 100
					}, {
						field: 'mark',
						title: '备注',
						showOverflow: false,
						width: 100
					}, {
						field: 'plantcode',
						title: '验证码',
						slots: {
							default ({
								row
							}) {
								return < img style = "height:150px"
								src = {
									row.plantcode
								}
								/>
							}
						}
					},
					{
						field: '',
						title: '操作',
						width: 65,
						fixed: "right",
						align: 'center',
						cellRender: {
							bind: this,
							name: '$operateButton',
							buttons: [{
								code: 'login',
								content: '登录',
								status: 'primary',
								inrow: true
							}]
						}
					}
				]
				gridOptions.toolbarConfig.buttons = []
				gridOptions.formConfig = false
				gridOptions.rowConfig.height = 150
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				}
			},
			login(e) {
				this.currentrow = e
				if (e.plantcode) {
					this.$prompt('请输入验证码', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({
						value
					}) => {
						this.loginhandle(value)
					}).catch(() => {

					})
				} else {
					this.$confirm('是否确认登录', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.loginhandle()
					}).catch(() => {

					})
				}
			},
			loginhandle(plantcode){
				this.loading = true
				this.$api.tool.externalLogin({
					id: this.currentrow.id,
					plantcode:plantcode
				}).then((res) => {
					this.$refs.external‌loginList.commitProxy('query')
					if (res == 1) {
						this.$message.success('登录成功')
					} else {
						this.$message.error('登录失败')
					}
				
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			list() {
				return new Promise((resolve) => {
					this.$api.mcp.account().then((res) => {
						resolve({
							list: res
						})
					})
					// resolve({
					// 	list: [{
					// 		id:'ERP',
					// 		code:'ERP',
					// 		name:'万里牛ERP'
					// 	},
					// 	{
					// 		id:'WMS',
					// 		code:'WMS',
					// 		name:'万里牛WMS'
					// 	},
					// 	{
					// 		id:'MES',
					// 		code:'MES',
					// 		name:'纳极智MES'
					// 	},
					// 	{
					// 		id:'XW',
					// 		code:'XW',
					// 		name:'小望'
					// 	},
					// 	{
					// 		id:'YQDZ',
					// 		code:'YQDZ',
					// 		name:'亿企赢'
					// 	}
					// 	]
					// })
				})
			},
			show() {
				this.progress = 0
				this.buff = true
			},
			hide() {
				this.progress = 0
				this.buff = false
				this.$emit('hide')
			},
		},
		components: {

		}
	}
</script>